const ElipseIcon = () => (
  <svg
    data-icon="ellipsis-vertical"
    role="img"
    viewBox="0 0 128 512"
    width="20"
    height="14"
    aria-hidden="true"
    color="#7086a7"
    className="elipse-icon"
    style={{ cursor: "pointer" }}
    data-test-subj="table-actions-button">
    <path
      fill="currentColor"
      d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"></path>
  </svg>
);

export default ElipseIcon;
